import ChargingRequestContainer from "./ChargingRequestContainer";
import ChargingRequestStore from "./ChargingRequestStore";

export default ChargingRequestStore(ChargingRequestContainer); 